<template>
    <div>
        <div class="row">
            <div class="col-md-4 col-12 mt-auto mb-auto">
                <h3>Sales Territory Management</h3>
                <div class="row mt-2">
                    <div class="col-md-4 mt-auto mb-auto">
                        <h6>Sales By Document</h6>
                    </div>
                    <div class="col-md-3 text-right">
                        <toggle-button 
                            class=""
                            v-model="by"
                            :width="50"
                            :height="25"
                            color="#7dCE94" 
                            :sync="true" 
                        />
                    </div>
                </div>

                

            </div>
            <div class="col-md-8 col-12 mt-auto mb-auto">
                <!-- <Multiselect 
                    :options="typeRadiusOptions.map(x => x.value)"
                    :custom-label="opt => typeRadiusOptions.find(x => x.value == opt).name"
                    v-model="typeRadius"
                    :allow-empty="false"
                /> -->
                <div class="row">
                    <div class="col-md mt-3 col-12">
                        <Multiselect 
                            v-if="kotaOptions.length > 0"
                            :options="kotaOptions.map(x => x.kode_kotakab)"
                            :custom-label="opt => kotaOptions.find(x => x.kode_kotakab == opt).nama_kotakab"
                            v-model="filter.city"
                            placeholder="Pilih Kota"
                        />
                    </div>
                    <div class="col-md mt-3 col-12">
                        <Multiselect 
                            :options="options.color.map(x => x.color)"
                            :custom-label="opt => options.color.find(x => x.color == opt).colorDesc"
                            v-model="filter.color"
                            placeholder="Pilih Warna Motor"
                        />
                    </div>
                    <div class="col-md mt-3 col-12">
                        <Multiselect 
                            :options="options.type.map(x => x.type)"
                            v-model="filter.type"
                            placeholder="Pilih Vehicle Type"
                        />
                    </div>
                    <div class="col-md mt-3 col-12">
                        <date-range-picker 
                            class="w-100 mr-4"
                            v-model="selectedDate"
                            style="min-height:43px"
                            ref="picker"
                            :opens="'left'"
                            :locale-data="{ firstDay: 1, format: 'MMM DD, YYYY' }"
                            
                        >
                            <template v-slot:input="picker" style="min-width: 350px;" class="text-center">
                                <i class="fa fa-calendar fa-fw ml-n1"></i> 
                                {{ moment(picker.startDate).format("DD/MM/YY")}} - {{ moment(picker.endDate).format("DD/MM/YY")}}
                                <b class="caret"></b>
                            </template>
                        </date-range-picker>
                    </div>
                    <div class="col-md mt-3 col-12 pb-3">
                        <button class="btn border border-secondary w-100 h-100">
                            Download CSV
                        </button>
                    </div>
                </div>

                
            </div>
        </div>

        <div v-if="!filter.city" class="mt-4 text-center">
            <!-- {{data}} -->
            <h3>City is required to use this feature.</h3>
        </div>
        <div v-else class="mt-4">

            <div style="position:relative;">


                <div  class="" style="z-index:3;position:absolute;right:20px;bottom:30px;" :style="{'width' : hideLegend ? '30%': '15%'}" :noExpand="true">
                    <div class="row pl-3 rounded shadow" style="background-color:rgba(255 , 255, 255 ,1);margin-right:-20px">
                        <div class="col-1 mt-auto mb-auto" :class="{'col-12 pt-3 pb-3 pr-1' : !hideLegend}">
                            <i class="fa fa-chevron-right" v-if="hideLegend" @click="hideLegend = !hideLegend"></i>
                            <div  v-else @click="hideLegend = !hideLegend" class="hoverLegend p-2">
                                
                                <i class="fa fa-chevron-left" > Show Legend</i>
                            </div>
                        </div>
                        <div v-if="hideLegend" class="col-11 pl-3 pr-3">
                            
                            <!-- <div class="row">
                                <div class="col-md-6 pb-1 pt-2" v-for="(legend , index) in legendRadius" :key="'check' + index">
                                    <div class="input-group checkbox">
                                        <input class="form-check-input mt-0" type="checkbox" v-model="showLegend" :value="legend.findValue" aria-label="Checkbox for following text input" :id="'legend' + 1">
                                        <label class="smallbox--outerbox mb-0" for="check1">
                                            <div class="smallbox" :style="{'background-color' : legend.color}"></div>
                                            <p class="mb-0 pl-2">{{legend.name}}</p>
                                        </label>
                                    </div>
                                </div>
                            </div> -->

                            <div class="row">
                                <div class="col-md-8 pb-0">
                                    <label class="color-grey">Status</label>
                                </div>
                                <div class="col-md-4 pb-0">
                                    <label class="color-grey">Unit</label>
                                </div>
                            </div>
                            <div class="row mt-0">
                                <!-- <div class="col-md-2 mt-2" style="padding-top:5px;padding-bottom:3px"><span class="circle" style="width:0.75rem;height:0.75rem;background-color: #324aa8;border: 1px solid black;"></span></div> -->
                                <div class="col-md-8 pt-1" style="display: flex; align-items: center; flex-direction: row;">
                                    <div class="circle" style="background-color:#324aa8;height:1.25em;width:1.25em;"></div>
                                    <label class="mb-0 pl-2 font-weight-bold">Purchase</label>
                                </div>
                                <!-- <div class="col-md-6">
                                </div> -->
                                <div class="col-md-4 pt-1 font-weight-bold">
                                    <label>{{numberWithCommas(total)}}</label>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>


                <l-map
                    :center="mapConfig.center"
                    :zoom="mapConfig.zoom"
                    ref="map"
                    style="min-height:650px;width:100%;z-index:0;position:relative"
                >   
                    <!-- Load Map Background (OpenStreetMap) -->
                    <l-tile-layer
                        :url="mapConfig.url"
                        :attribution="mapConfig.attribution"
                    />
                    <!-- Create White Background -->
                    <l-circle 
                        :lat-lng="latLng(mapConfig.center[0] , mapConfig.center[1])"
                        :radius="10000000"
                        :fillColor="'#FFFFFF'"
                        :fillOpacity="0.55"
                        :color="'#46769A'"
                        :weight="1"
                    />

                    <l-geo-json
                        v-if="geoJSONArea"
                        :geojson="geoJSONArea"
                        :options="optionsFeatures"
                        :options-style="styleFunction('#CCE85A')"
                    />

                    <!-- <template v-if="dealerRadius">
                        <template v-if="typeRadius == 2">
                        
                            
                            <l-geo-json
                                :geojson="geojsonRing1"
                                :options="optionsFeatures"
                                :options-style="styleFunction('#F21C1E')"
                            />
                            <l-geo-json
                                :geojson="geojsonRing2"
                                :options="optionsFeatures"
                                :options-style="styleFunction('#AF73F2')"
                            />
                            <l-geo-json
                                :geojson="geojsonRing3"
                                :options="optionsFeatures"
                                :options-style="styleFunction('#668DAB')"
                            />
                            <l-geo-json
                                :geojson="geojsonLocation"
                                :options="optionsFeatures"
                                :options-style="styleFunction('#CCE85A')"
                            />

                        </template>
                        <template>
                            <div>
                                <template v-for="(circle , index) in configRadius">
                                    <l-circle 
                                        v-if="showLegend.includes(circle.findValue)"
                                        :key="index + 'RadiusCircle'"
                                        
                                        :lat-lng="latLng(mapConfig.center[0] , mapConfig.center[1])"
                                        :radius="circle.distance"
                                        :fillColor="circle.color"
                                        :fillOpacity="0"
                                        :color="circle.color"
                                        :weight="1"
                                    />
                                </template>
                            </div>
                        </template>
                    </template> -->

                    <!-- <l-marker :lat-lng="latLng(mapConfig.center[0] , mapConfig.center[1])" :icon="dealerMarkerIcon"  :zIndexOffset="1000">
                        <l-popup :content="'Dealer Name : <b>' + dealer.name + '</b>' "/>
                    </l-marker> -->

                    <l-marker v-for="(data , index) in points" :lat-lng="latLng(data.lat , data.lng)"  :icon="data.icon">
                        <l-tooltip :content="data.contentText"/>
                    </l-marker>
            
                </l-map>
            </div>
            

            <!-- {{data}} -->
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { ToggleButton } from 'vue-js-toggle-button'
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'

// Map stuff
import { latLng , icon , divIcon , map, geoJSON } from "leaflet";
import { LMap, LTileLayer, LMarker, LGeoJson, LIcon, LPopup, LTooltip, LCircle } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet/dist/leaflet.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

export default {
    components : {
        Multiselect,
        ToggleButton,
        DateRangePicker,
        // Map Stuff
        LMap,
        LTileLayer,
        LIcon,
        LGeoJson,
        LMarker,
        LPopup,
        LTooltip,
        LCircle,
        'v-marker-cluster': Vue2LeafletMarkerCluster,
    },
    computed : {
        optionsFeatures() {
            return {
                onEachFeature: this.onEachFeatureFunction
            };
        },
        dealerMarkerIcon () {
            let height = 25
            let width = 25
            return icon({
                iconUrl: '/honda.png',
                iconSize:      [width, height], // size of the icon
                // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
            });
        },
        onEachFeatureFunction() {
            return (feature, layer) => {
                // console.log(layer)
                if(feature.properties.typeDealer) {
                    layer.bindTooltip(
                        `</div><div>${feature.properties.typeDealer}: ` +
                        feature.properties.ADM3_EN +
                        "</div><div>Nama Kota: " +
                        feature.properties.ADM2_EN +
                        "</div><div>Total: "+
                        feature.properties.total 
                    ,
                    { permanent: false, sticky: true }
                    );
                }
                else {
                    layer.bindTooltip(
                        `</div><div>Nama Lokasi : ${feature.properties.ADM3_EN}</div>`
                    ,
                    { permanent: false, sticky: true }
                    );
                }
                
            };
        }
    },
    data () {
        let start = new moment().startOf('month').format("Y-MM-DD")
        let end = new moment().format("Y-MM-DD")

        return {
            // Library
            moment,
            latLng,
            // Variables
            typeRadius : 2,
            by : false,
            options : this.$store.getters.getFilterOptions,
            kotaOptions : [],
            selectedDate : {
                startDate : start,
                endDate : end
            },
            filter : {
                city : null,
                by : 'SCAN',
                start : start,
                end : end,
                type : null,
                color : null
            },
            data : null,
            // Maps
            mapConfig : {
                center : ["-7.257621004195039","112.75208164629598"],
                zoom : 11,
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution:
                    '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            },
            dealer : null,
            points : null,
            hideLegend : true,
            geoJSONArea : null,
            geojson : null,
            loading : false,
            configRadius : [],
            total : 0,
            showLegend : ['ring1' , 'ring2' , 'ring3'],
            legendKecamatan : [{
                name : 'Other',
                findValue : 'OTHER',
                total : 0,
                color : '#C39E56'
            },{
                name : 'Ring 1',
                findValue : 'RING 1',
                total : 0,
                color : '#C39E56'
            },{
                name : 'Ring 2',
                findValue : 'RING 2',
                total : 0,
                color : '#C39E56'
            },{
                name : 'RING 3',
                findValue : 'RING 3',
                total : 0,
                color : '#C39E56'
            },{
                name : 'Lokasi',
                findValue : 'LOKASI',
                total : 0,
                color : '#C39E56'
            }],
            legendRadius : [{
                name : '0 - 5 KM',
                findValue : 'ring1',
                total : 0,
                color : '#938032'
            },{
                name : '5 - 10 KM',
                findValue : 'ring2',
                total : 0,
                color : '#F21C1E'
            },{
                name : '10 - 15 KM',
                findValue : 'ring3',
                total : 0,
                color : '#3388ff'
            }],
            legendShow : {
                radius : null,
                kecamatan : null
            }
        }
    },
    mounted () {
        this.loadKota()
        this.loadAPI()
    },
    watch : {
        selectedDate : {
            deep : true,
            handler () {
                this.filter.start = new moment(this.selectedDate.startDate).format('Y-MM-DD')
			    this.filter.end = new moment(this.selectedDate.endDate).format('Y-MM-DD')
                this.loadAPI()
            }
        },
        'filter.city' : function () {
            this.loadAPI()
        },
        'filter.type' : function () {
            this.loadAPI()
        },
        'filter.color' : function () {
            this.loadAPI()
        },
        by : function () {
            this.filter.by = this.by ? 'DOCUMENT' : 'SCAN'
            this.loadAPI()
        }
    },
    methods : {
        loadKota () {
            this.$http.get('/api/master/city-map')
            .then((resp) => {
                this.kotaOptions = resp.data.data
                this.filter.city = 'ID3578'
            })
            .catch((err) => {
                console.log(err)
            })
        },
        styleFunction(fillColor) { // important! need touch fillColor in computed for re-calculate when change fillColor
            return {
                weight: 2,
                color: "#555",
                opacity: 1,
                fillColor: fillColor,
                fillOpacity: 0.36,
            };
        },
        loadAPI () {
            if(!this.filter.city) return;

            let url = '/api/highlight/ttm-sales-record?'
            url = this.initialiseFilter(url , this.filter)

            this.$http.get(url)
            .then((resp) => {
                let data = resp.data.data
                this.processData(data)
            })
            .catch((err) => {
                console.log(err)
            })




        },
        async processData (data) {
            try {
                this.total = 0

                /* Load GEOJSON ( Use googleapi storage for Production ) */

                const response = await fetch(`https://storage.googleapis.com/mpm-geojson-id/Jawa%20Timur.json`)
                let jawaTimur = await response.json();
                const response2 = await fetch(`https://storage.googleapis.com/mpm-geojson-id/NTT.json`)
                let ntt = await response2.json();

                jawaTimur.features =  jawaTimur.features.concat(ntt.features)

                this.geojson = jawaTimur

                // Load Geojson for Each Kecamatan in Kota

                let filteredCity = this.geojson.features.filter(x => x.properties.ADM2_PCODE == this.filter.city)

                this.geoJSONArea = {
                    type : 'FeatureCollection',
                    features : filteredCity
                }

                console.log(this.geoJSONArea)
                

                // Process Points from Data
                let points = data.points.filter(x => x.lat != '' && x.lng != '')

                this.total = points.length

                let styleText = `
                    width: 0.75rem;
                    height: 0.75rem;
                    display: block;
                    
                    position: relative;
                    left: 0rem;
                    top: 0rem;
                    background-color: #324aa8;
                    border: 1px solid black;
                `

                points.forEach(async (point) => {
                    point.contentText = `
                        Engine Number : <b>${ point.engine_no }</b><br>
                        Vehicle Type : <b>${ point.type }</b><br>
                        Commercial Name : <b>${ point.commercial_name ? point.commercial_name : '-' }</b><br>
                        Color : <b>${ point.color_description ? point.color_description : '-' }</b><br>
                        Lat : <b>${ point.lat }</b>, Lng :  <b>${ point.lng }</b><br>
                    `
                    
                    let html = `<span style="${styleText}" class="circle" />`
                    point.icon = divIcon({
                        className: "my-custom-pin",
                        iconAnchor: [0, 5],
                        labelAnchor: [-6, 0],
                        popupAnchor: [-12, -9],
                        html: html
                    })
                })


                this.points = points
                this.data = data

            }
            catch(err) {
                console.log(err)
            }
        },
        calculateFeatures(selectedGeojson , typeDealer , areaDealer , dealerData , exclusion) {
            let obj = {
                type : 'FeatureCollection',
                features : []
            }

            for(var i = 0 ; i < this.geojson.features.length ; i++) {
                let curGeoJson = this.geojson.features[i]
                let selectedAreaDealer = areaDealer.find(x => x.id_kecamatan == curGeoJson.properties.ADM3_PCODE)
                if(selectedAreaDealer)
                {
                    obj.features.push(curGeoJson)
                    curGeoJson.properties.typeDealer = typeDealer
                    curGeoJson.properties.total = selectedAreaDealer.service
                    let legend = this.legendShow.kecamatan.find(x => x.findValue == selectedAreaDealer.ring)
                    legend.total += selectedAreaDealer.service
                    this.total += selectedAreaDealer.service
                }
            }

            this[selectedGeojson] = obj
        },
    }
}
</script>

<style>
.circle {
    border-radius: 3rem 3rem;
}

.color-grey {
    color: grey;
}

.smallbox--outerbox {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.smallbox {
    width: 1em;
    height: 1em;
    border-radius: 2px;
}

.checkbox.input-group .form-check-input {
    transform: translateY(20%);
}

.ring1 {
    background-color: red;
}

.ring2 {
    background-color: blue;
}

.ring3 {
    background-color: green;
}

</style>